// extracted by mini-css-extract-plugin
export var container = "_4w-0";
export var infoButton = "_4w-1";
export var label = "_4w-3";
export var labelExpanded = "_4w-4";
export var price = "_4w-5";
export var priceExpanded = "_4w-6";
export var title = "_4w-2";